module["exports"] = [
  "кв. ###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/address/secondary_address.js
// module id = 1653
// module chunks = 1